/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { cloneDeep } from 'lodash'
import moment from 'moment'

import { API } from '../api/api'
import { fetch, post, put } from '../api/httpClient'
import localStorageService from '../api/localStorageService'
import {
  ANS_CUSTOMER_ID,
  DATEFORMAT,
  ENABLE_CALENDAER,
  ENABLE_ESSAY,
  ENABLE_EVENT,
  ENABLE_FAMILY_LOGIN,
  ENABLE_MODULE_PROGRESS,
  ENABLE_PROFILE_PERCENTAGE,
  ENABLE_PROGRAM_SELECTION,
  ENABLE_REGISTRATION_REVIEW,
  ENABLE_SUCCESS_COACH,
  ENABLE_WALLET,
  ESSAY_QUESTION,
  GA_ENABLE,
  GA_ID,
  GTM_ID,
  IS_SHOW_GRADE_SCALE,
  LEARNSTAGE_LMS,
  OASES_SCHOOL_ID,
  ON_MAINTENANNCE,
  parentDetailsInitialState,
  PRIVACY_POLICY,
  REENROLL_COURSES,
  SCHOOL_GENDER,
  SCHOOL_THEME,
  STUDENT_AGE,
  STUDENT_APPROVAL,
  SUPPORT_WIDGET_CODE,
  TERMS_OF_USE,
  userDetailsInitialState,
  UsPhoneCode,
} from '../helpers/constants'
import buttonLoaderEvent from '../helpers/custom-events/buttonLoaderEvent'
import { selectIntrospect, selectSchool, selectUser } from '../helpers/selectors'
import {
  applySchoolTheme,
  formatDate,
  get,
  getDashAddedPhone,
  getDashRemovedPhone,
  getFullName,
  isEmpty,
  isNullOrEmpty,
  mapStateWithData,
  readInfoFromURN,
  userProfileCompleteness,
} from '../helpers/utils'
import ActionTypes from './actionTypes'
import { schoolAction } from './app.action'
import { introspectCall } from './auth.action'
import { smsSettingsInfoCall } from './sms.actiom'

const calculateProfileCompleteness = (user) => {
  let profileComplete = 0
  if (user.avatar) {
    profileComplete += userProfileCompleteness.avatar
  }
  if (user.prefix) {
    profileComplete += userProfileCompleteness.prefix
  }
  if (user.first_name) {
    profileComplete += userProfileCompleteness.first_name
  }
  if (user.middle_name) {
    profileComplete += userProfileCompleteness.middle_name
  }
  if (user.last_name) {
    profileComplete += userProfileCompleteness.last_name
  }
  if (user.suffix) {
    profileComplete += userProfileCompleteness.suffix
  }
  if (user.nick_name) {
    profileComplete += userProfileCompleteness.nick_name
  }
  if (user.dob) {
    profileComplete += userProfileCompleteness.dob
  }
  if (user.gender) {
    profileComplete += userProfileCompleteness.gender
  }
  if (user.ethnicity) {
    profileComplete += userProfileCompleteness.ethnicity
  }
  if (user?.address?.adr_address1) {
    profileComplete += userProfileCompleteness.adr_address1
  }
  if (user?.address?.adr_address2) {
    profileComplete += userProfileCompleteness.adr_address2
  }
  if (user?.address?.adr_country_iso) {
    profileComplete += userProfileCompleteness.adr_country_name
  }
  if (user?.address?.adr_state_iso) {
    profileComplete += userProfileCompleteness.adr_state_name
  }
  if (user?.address?.adr_city) {
    profileComplete += userProfileCompleteness.adr_city
  }
  if (user?.address?.adr_zipcode) {
    profileComplete += userProfileCompleteness.adr_zipcode
  }
  if (user?.address?.adr_email) {
    profileComplete += userProfileCompleteness.email
  }
  if (user?.address?.adr_mobile_prefix) {
    profileComplete += userProfileCompleteness.adr_mobile_prefix
  }
  if (user?.address?.adr_mobile) {
    profileComplete += userProfileCompleteness.adr_mobile
  }
  if (user?.address?.adr_phone_prefix) {
    profileComplete += userProfileCompleteness.adr_phone_prefix
  }
  if (user?.address?.adr_phone) {
    profileComplete += userProfileCompleteness.adr_phone
  }
  if (user.uploadIdUrl) {
    profileComplete += userProfileCompleteness.upload_id
  }
  user.profileCompletePercentage = profileComplete || 0
}

export const userAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.USER,
    data,
  })

export const registerUserCall =
  (payload, successCallback, failureCallback) => async (_, getState) => {
    try {
      const state = getState()
      const school = selectSchool(state)
      const updatedPayload = {
        email: payload.email?.toLowerCase()?.trim(),
        password: payload.password,
        tncAccepted: payload.tncAccepted,
        school_realm_name: school.sch_school_public_id,
        pgm_id: payload.pgm_id,
      }
      const { data } = await post(API.CUSTOMER, updatedPayload)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const userByEmailCall = (successCallback, failureCallback) => async (dispatch, getState) => {
  try {
    const state = getState()
    let user = selectUser(state)
    const introspect = selectIntrospect(state)
    if (isEmpty(user) && isEmpty(introspect)) {
      return
    }
    if (isEmpty(user)) {
      user = {
        email: introspect.username,
      }
    }
    const url = `${API.CUSTOMER}/${user.email}`
    const { data } = await fetch(url)
    data.isStudent = get(introspect, 'attributes.is_student[0]', '') === 'true'
    modifyUserItem(data)
    calculateProfileCompleteness(data)
    const { address, ...rest } = data
    const userRequiredInfo = mapStateWithData({ ...rest, ...address }, userDetailsInitialState)
    const parentRequiredInfo = mapStateWithData({ ...rest, ...address }, parentDetailsInitialState)
    const profileCompleted = Object.values(
      data.isStudent ? userRequiredInfo : parentRequiredInfo
    ).some((value) => {
      return isNullOrEmpty(value)
    })
    await dispatch(
      smsSettingsInfoCall((info) => {
        dispatch(
          userAction({
            ...data,
            isMobileVerified: info.is_mobile_verfied,
            verifiedPhonePrefix: info.mobile_prefix,
            verifiedPhoneNumber: info.mobile_no,
            enableSms: info.enable_sms,
            isProfileCompleted: introspect?.session_metadata?._adminInitializedSession
              ? true
              : !profileCompleted,
          })
        )
      })
    )
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const loginAsCall =
  ({ urn, sessionEnd }, successCallback, failureCallback) =>
  async () => {
    try {
      const [, realm] = readInfoFromURN(urn)
      let url = `${API.CORE.LOGIN_AS}?urn=${encodeURIComponent(urn)}&realm=${realm}`
      if (sessionEnd) {
        url += `&sessionEnd=${sessionEnd}`
      }
      await fetch(url)
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const userDetailByUserName = (userName, successCallback, failureCallback) => async () => {
  try {
    if (isEmpty(userName)) {
      return
    }
    const url = `${API.CUSTOMER}/${userName}`
    const { data } = await fetch(url)
    modifyUserItem(data)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const userByEmailPublicCall =
  (email = '', successCallback, failureCallback) =>
  async () => {
    try {
      const url = `${API.CUSTOMER}/byEmail/${email.trim()}`
      const { data } = await fetch(url)
      modifyUserItem(data)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }
const modifyUpdateCall = (data) => {
  const updatedata = cloneDeep(data)
  updatedata.mobile_phone = updatedata.mobile_phone
    ? getDashRemovedPhone(updatedata.mobile_phone)
    : ''
  if (updatedata.address) {
    updatedata.address.adr_mobile = updatedata?.address.adr_mobile
      ? getDashRemovedPhone(updatedata?.address.adr_mobile)
      : ''
    updatedata.address.adr_phone = updatedata?.address.adr_phone
      ? getDashRemovedPhone(updatedata?.address.adr_phone)
      : ''
  }
  // if (updatedata.parents) {
  //   updatedata.parents = updatedata?.parents.map((updatedata) => {
  //     updatedata.home_phone_number = updatedata?.home_phone_number.split('-').join('') || ''
  //     updatedata.primary_phone_number = updatedata?.primary_phone_number.split('-').join('') || ''
  //   })
  if (updatedata.parents) {
    for (const p of updatedata.parents) {
      p.home_phone_number = p?.home_phone_number ? getDashRemovedPhone(p.home_phone_number) : ''
      p.primary_phone_number = p?.primary_phone_number
        ? getDashRemovedPhone(p.primary_phone_number)
        : ''
    }
  }
  return updatedata
}

export const updateUserCall =
  (payload, successCallback, failureCallback) => async (dispatch, getState) => {
    const updatedata = modifyUpdateCall(payload)
    const { address, parents, ...rest } = updatedata
    try {
      buttonLoaderEvent.publish(true)
      const state = getState()
      const user = selectUser(state)
      const url = `${API.CUSTOMER}/${user.email}`
      const updatedPayload = {
        ...rest,
        email: rest?.email?.toLowerCase()?.trim(),
        dob: `${moment(rest.dob).format(DATEFORMAT)}`,
        // dob: rest.dob && typeof rest.dob === 'object' ? rest.dob.getTime() : rest.dob,
      }
      const formPayload = new FormData()
      Object.keys(updatedPayload).forEach((key) => {
        formPayload.append(key, updatedPayload[key])
      })
      if (!isEmpty(address)) {
        Object.keys(address).forEach((key) => {
          if (key === 'email') {
            formPayload.append(`address[${key}]`, address[key]?.toLowerCase()?.trim())
          } else if (key === 'adr_email') {
            formPayload.append(`address[${key}]`, address[key]?.toLowerCase()?.trim())
          } else formPayload.append(`address[${key}]`, address[key])
        })
      }
      if (!isEmpty(parents)) {
        parents.forEach((parent, i) => {
          Object.keys(parent).forEach((key) => {
            if (key === 'email') {
              formPayload.append(`parents[${i}][${key}]`, parent[key]?.toLowerCase()?.trim())
            } else if ((key === 'suffix' || key === 'prefix') && parent[key] === 'none') {
              formPayload.append(`parents[${i}][${key}]`, '')
            } else if (key === 'dob') {
              formPayload.append(`parents[${i}][${key}]`, moment(parent[key]).format(DATEFORMAT))
            } else {
              formPayload.append(`parents[${i}][${key}]`, parent[key])
            }
          })
        })
      }
      const { data } = await put(url, formPayload)
      buttonLoaderEvent.publish(false)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      buttonLoaderEvent.publish(false)
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchMetadata = (_, failureCallback) => async (dispatch, getState) => {
  try {
    const state = getState()
    const school = selectSchool(state)
    const metaKeys = `metaKeys=${STUDENT_AGE}&metaKeys=${ENABLE_ESSAY}&metaKeys=${ESSAY_QUESTION}&metaKeys=${STUDENT_APPROVAL}&metaKeys=${ENABLE_PROGRAM_SELECTION}&metaKeys=${SCHOOL_THEME}&metaKeys=${ENABLE_REGISTRATION_REVIEW}&metaKeys=${ENABLE_PROFILE_PERCENTAGE}&metaKeys=${ENABLE_WALLET}&metaKeys=${SUPPORT_WIDGET_CODE}&metaKeys=${ENABLE_EVENT}&metaKeys=${ENABLE_CALENDAER}&metaKeys=${ENABLE_SUCCESS_COACH}&metaKeys=${OASES_SCHOOL_ID}&metaKeys=${ENABLE_FAMILY_LOGIN}&metaKeys=${ENABLE_MODULE_PROGRESS}&metaKeys=${SCHOOL_GENDER}&metaKeys=${REENROLL_COURSES}&metaKeys=${ANS_CUSTOMER_ID}&metaKeys=${GA_ENABLE}&metaKeys=${GTM_ID}&metaKeys=${GA_ID}&metaKeys=${IS_SHOW_GRADE_SCALE}&metaKeys=${TERMS_OF_USE}&metaKeys=${PRIVACY_POLICY}&metaKeys=${ON_MAINTENANNCE}`

    const url = `${API.CORE.METADATA}?metaType=school&metaTypeId=${school.sch_id}&${metaKeys}`
    let { data } = await fetch(url)
    data = data.reduce((value, currentItem) => {
      value[currentItem.md_meta_key] = checkForTypes(
        currentItem.md_meta_key,
        currentItem.md_meta_value
      )
      return value
    }, {})
    if (!data.school_theme) {
      data.school_theme = 'eden'
    }
    applySchoolTheme(data.school_theme)
    dispatch({
      type: ActionTypes.METADATA,
      data,
    })
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchLmsConfiguration = (_, failureCallback) => async (dispatch, getState) => {
  try {
    const state = getState()
    const school = selectSchool(state)
    const url = `${API.CORE.LMS_CONFIG}/${school.sch_id}`
    const { data } = await fetch(url)
    const isLearnstageActive = data?.some(
      (item) => item.lmc_name === LEARNSTAGE_LMS && item.lmc_active === 1
    )
    dispatch(schoolAction({ ...school, isLearnstageActive: isLearnstageActive }))
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

const modifyUserItem = function (data) {
  if (isEmpty(data)) {
    return
  }
  data.dobLabel = !isNullOrEmpty(data?.dob) ? formatDate(data?.dob, DATEFORMAT) : ''
  data.uploadIdUrl = data?.upload_id ? data?.upload_id.split('/').pop() : ''
  data.avatar_file = data.avatar ? data.avatar : ''
  data.mobile_phone = data.mobile_phone
    ? data.mobile_phone_prefix === UsPhoneCode
      ? getDashAddedPhone(data.mobile_phone)
      : data.mobile_phone
    : ''
  data.home_phone = data.home_phone
    ? data.home_phone_prefix === UsPhoneCode
      ? getDashAddedPhone(data.home_phone)
      : data.home_phone
    : ''
  if (data.address) {
    data.address.adr_mobile = data.address.adr_mobile
      ? data.address.adr_mobile_prefix === UsPhoneCode
        ? getDashAddedPhone(data.address.adr_mobile)
        : data.address.adr_mobile
      : ''
    data.address.adr_phone = data.address.adr_phone
      ? data.address.adr_phone_prefix === UsPhoneCode
        ? getDashAddedPhone(data.address.adr_phone)
        : data.address.adr_phone
      : ''
  }
  data.fullName = getFullName(data)
  if (data.parents) {
    data.parents = data.parents.map((data) => {
      data.dobLabel = !isNullOrEmpty(data?.dob) ? formatDate(data?.dob, DATEFORMAT) : ''
      data.home_phone_number = data?.home_phone_number
        ? data.home_phone_number_prefix === UsPhoneCode
          ? getDashAddedPhone(data?.home_phone_number)
          : data?.home_phone_number
        : ''
      data.primary_phone_number = data?.primary_phone_number
        ? data.primary_phone_number_prefix === UsPhoneCode
          ? getDashAddedPhone(data?.primary_phone_number)
          : data?.primary_phone_number
        : ''
      if (data?.address) {
        data.address.adr_mobile = data.address.adr_mobile
          ? data.address.adr_mobile_prefix === UsPhoneCode
            ? getDashAddedPhone(data.address.adr_mobile)
            : data.address.adr_mobile
          : ''
        data.address.adr_phone = data.address.adr_phone
          ? data.address.adr_phone_prefix === UsPhoneCode
            ? getDashAddedPhone(data.address.adr_phone)
            : data.address.adr_phone
          : ''
      }
      return data
    })
  }

  return data
}

export const updateTourStateCall =
  (successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const introspect = selectIntrospect(state)
      const url = `${API.CORE.TOUR}/${introspect.username.trim()}`
      await put(url)
      dispatch(introspectCall())
      localStorageService.clearTourState()
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

const checkForTypes = (key, value) => {
  if (value === '1') {
    return true
  } else if (value === '0') {
    return false
  } else if (key === SCHOOL_GENDER || key === REENROLL_COURSES) {
    return JSON.parse(value || '[]')
  } else {
    return value
  }
}
